export default "__VITE_ASSET__df72707a__"